<template>
  <img class="video-icon" :src="videoIcon" />
</template>

<script>
export default {
  name: "VideoIcon",
  computed: {
    videoIcon() {
      return this.$store.getters.image_button_filme_instrumente;
    }
  }
};
</script>
<style scoped>
.video-icon {
  max-width: 80px;
  max-height: 80px;
  height: 10vw;
  width: 10vw;
}
</style>
